// Module
var code = `<div appHeaderBar>
    <header-bar-title>Make A Payment</header-bar-title>
</div>

<app-page-content [showWebFooter]="true" [usePagePadding]="true">
    <app-cobrand-header [property]="property.nickname"
                        [manager]="property.hoa.pmc.name"
                        [association]="property.hoa.name"
                        [makePayment]="true">
    </app-cobrand-header>

    <div class="HOA-misc-guidedSteps__container">
        <div class="HOA-container__header">
            <!-- TODO: Add the blue bar and header formatting -->
            <div class="HOA-container__header-text" tid="pageTitle" id="pageTitle">One-Time Payment Summary</div>
        </div>
        <div class="HOA-container__content">
            <!-- Schedule Details-->
            <div class="HOA-flex-component HOA-make-payment-item-row">
                <div class="HOA-flex-component HOA-make-payment-flex-align HOA-make-payment-fancy-width">
                    <span class="u-fontBold">Property Address</span>
                </div>
                <div class="HOA-make-payment-item-row-amount u-textRight">
                    <div>
                        <span tid="addressLine1" id="addressLine1">{{property.address.line1}}</span>
                        <br />
                        <span tid="addressLine2" id="addressLine2">{{property.address.line2}}</span>
                    </div>
                    <div>
                        <span tid="city" id="city">{{property.address.city}}</span>,
                        <span tid="state" id="state">{{property.address.state}}</span>
                        <span tid="postalCode" id="postalCode">{{property.address.postalCode}}</span>
                    </div>
                </div>
            </div>
            <ng-container *ngIf="paymentScheduleRequest.startDate && paymentScheduleRequest.startDate.formattedFullDate">
                <div class="HOA-flex-component u-pB6 HOA-make-payment-item-row">
                    <div class="HOA-flex-component HOA-make-payment-flex-align HOA-make-payment-fancy-width">
                        <span class="u-fontBold">Payment Name</span>
                    </div>
                    <div class="HOA-make-payment-item-row-amount u-textRight">
                        <span tid="paymentName" id="paymentName">{{paymentScheduleRequest.startDate.formattedFullDate}}</span>
                    </div>
                </div>
                <div class="HOA-flex-component u-pB6 HOA-make-payment-item-row">
                    <div class="HOA-flex-component HOA-make-payment-flex-align HOA-make-payment-fancy-width">
                        <span class="u-fontBold">Payment Date</span>
                    </div>
                    <div class="HOA-make-payment-item-row-amount u-textRight">
                    <span tid="paymentDate" id="paymentDate">
                        {{paymentScheduleRequest.startDate.formattedFullDate}}
                    </span>
                    </div>
                </div>
            </ng-container>
            <div class="HOA-flex-component u-pB6 HOA-make-payment-item-row">
                <div class="HOA-flex-component HOA-make-payment-flex-align HOA-make-payment-fancy-width">
                    <span class="u-fontBold">Payment Method</span>
                </div>
                <div class="HOA-make-payment-item-row-amount u-textRight" *ngIf="paymentScheduleRequest.paymentMethod">
                    <span tid="paymentMethodNickname" id="paymentMethodNickname">
                        {{paymentScheduleRequest.paymentMethod.nickname}}
                    </span>
                    <span *ngIf="paymentScheduleRequest.paymentMethod.maskedId"
                          tid="maskedId"
                          id="maskedId">
                        ({{paymentScheduleRequest.paymentMethod.maskedId}})
                    </span>
                </div>
            </div>

            <!--Administrative Fee-->
            <div class="HOA-flex-component u-pB6 HOA-make-payment-item-row"
                 *ngIf="convenienceFee">
                <div class="HOA-flex-component HOA-misc-guidedSteps__flex-align HOA-make-payment-fancy-width">
                    <span class="u-fontBold u-pR1">Administrative Fee</span>
                </div>
                <div class="HOA-make-payment-item-row-amount u-textRight">
                    <span tid="convenienceFee" id="convenienceFee">
                        {{convenienceFee | currency}}
                    </span>
                </div>
            </div>

            <!--Total-->
            <div class="HOA-flex-component u-pB6 HOA-make-payment-item-row">
                <div class="HOA-flex-component HOA-misc-guidedSteps__flex-align HOA-make-payment-fancy-width">
                    <span class="u-fontBold u-pR1">Total Amount</span>
                </div>
                <div class="HOA-make-payment-item-row-amount u-textRight">
                    <span
                          tid="paymentAmount"
                          id="paymentAmount"
                          class="HOA-make-payment-amount-total">
                        {{paymentScheduleRequest.futurePayments[0].total | currency}}
                    </span>
                </div>
            </div>

            <input type="checkbox"
                   id="tcCheckbox"
                   name="tcCheckbox"
                   tid="tcCheckbox"
                   class="Field u-cf"
                   style="margin-bottom: 26px; accent-color: #00505c"
                   [(ngModel)]="tcCheckbox"
                   [ngClass]="{'is-invalid': false}">
            <label for="tcCheckbox" class="HOA-font-light">
                I agree to pay the total amount due including administrative fees.
            </label>

            <div class="u-pT2 HOA-flex-component HOA-flextable-component__flex-end">
                <button name="cancel"
                        id="cancel"
                        tid="cancel"
                        type="button" class="Button Button--link HOA-make-payment-button"
                        [routerLink]="['/properties', property.id, 'payment']"
                        [state]="{propertyId: property.id}">
                    Back
                </button>
                <button name="submit"
                        id="submit"
                        tid="submit" [disabled]="!tcCheckbox || disableSubmitBtn"
                        type="submit"
                        class="Button Button--blue" ifOverFlowXClass="Button--overflowX"
                        (click)="submit()">
                    Submit Payment
                </button>
            </div>
            <span class="HOA-Field-detail HOA-make-payment-disclaimer">
                Payments are processed Monday through Friday, excluding holidays.
                Payments submitted on weekends or holidays may be delayed.
            </span>
        </div>
    </div>
</app-page-content>`;
// Exports
module.exports = code;